// Per-document-type printer preference (per device, desktop app only)
export const DOC_PRINTER_TYPES = [
  { id: "ticket", label: "🧾 Ticket 80mm 小票" },
  { id: "pedido", label: "📋 Pedido 订货单" },
  { id: "nota", label: "🚚 Nota de Entrega 送货单" },
  { id: "factura", label: "🧾 Factura 发票" },
  { id: "nc", label: "💳 Nota de Crédito 贷记单" },
  { id: "a4", label: "📄 A4 通用" },
];

export function getDocPrinter(docType) {
  return localStorage.getItem(`sellox_printer_${docType}`) || localStorage.getItem("sellox_b2b_printer") || "";
}

export function setDocPrinter(docType, name) {
  localStorage.setItem(`sellox_printer_${docType}`, name || "");
}

export function docPrintOpts(docType) {
  const p = getDocPrinter(docType);
  return p ? { printerName: p } : undefined;
}
